import React from 'react';
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { showNotification } from './../../../utils';

const TemplatesP7 = (props) => {
    const renderDepartments = () => {
        if (props.fetching) {
            return <div><i className="fas fa-circle-notch fa-spin" /> Loading data...</div>;
        }

        return props.departments.map((department) => {
            // if (props.user && parseInt(props.user.id) !== 175 && parseInt(props.user.id) !== 242 && parseInt(department.id) === 420) {
            //     return null;
            // }

            let imageUrl = require('./../images/no-image.jpg');
            if (department.image_url && department.image_url != null && department.image_url !== '' && department.image_url !== '-') {
                imageUrl = department.image_url;
            }

            const imageStyle = {
                backgroundImage: 'url("' + imageUrl + '")',
                backgroundSize: 'cover',
            };

            let url = '/product/' + props.productId + '/' + department.id;
            if (department.is_last_level) {
                url = '/department/' + props.productId + '/' + department.id;
            }

            let departmentName = department.name;
            if ([421, 422, 423].includes(parseInt(department.id))) {
                departmentName = (
                    <Fragment>
                        <div>UTHealth Houston</div>
                        <div>{department.name}</div>
                    </Fragment>
                );
            }

            return (
                <div className="category" key={department.id}>
                    <Link to={url}><div className="image" style={imageStyle}></div></Link>
                    <div className="title">
                        <div className="name">{departmentName}</div>
                        <div className="button-container">
                            <Link to={url}><button>Select</button></Link>
                        </div>
                    </div>
                </div>
            );
        });
    };

    const handleSearch = () => {
        if (props.search === '') {
            return showNotification('Enter a value', 'Enter a text to search', 'info');
        }

        props.history.push('/search/' + props.productType + '/' + props.search);
    };

    const keyPressHandler = (event) => {
        if (event.key === 'Enter') {
            if (props.search === '') {
                return showNotification('Enter a value', 'Enter a text to search', 'info');
            }

            props.history.push('/search/' + props.productType + '/' + props.search);
        }
    }

    let breadcrumbsContainer = null;
    if (parseInt(props.productId) === 7 && props.departments.length > 0) {
        const breadcrumbs = [<Link to="/utp">Main Categories</Link>, ' / '];

        if (props.departments[0].uthealth_department_id == null) {
            breadcrumbs.push('Apparel Categories');
        } else {
            breadcrumbs.push(<Link to="/product/7">Apparel Categories</Link>);

            for (let i = 0; i < props.departments[0].breadcrumbs.length; i++) {
                if (i === props.departments[0].breadcrumbs.length - 1) {
                    breadcrumbs.push(' / ', props.departments[0].breadcrumbs[i].label);
                } else {
                    breadcrumbs.push(' / ', <Link to={'/product/7/' + props.departments[0].breadcrumbs[i].id}>{props.departments[0].breadcrumbs[i].label}</Link>);
                }
            }
        }

        breadcrumbsContainer = (
            <div className="breadcrumbs">/ {breadcrumbs}</div>
        );
    }

    return (
        <div className="templates-container">
            {breadcrumbsContainer}
            <div className="search-container">
                <div className="search-field">
                    <input
                        type="text"
                        placeholder="Search here..."
                        value={props.search}
                        onChange={(event) => props.setSearch(event.target.value)}
                        onKeyPress={keyPressHandler}
                    />
                    <select
                        value={props.productType}
                        onChange={(event) => props.setProductType(event.target.value)}
                    >
                        <option value="1">Cards</option>
                        <option value="17">Pocket Folders</option>
                        <option value="2">Letterheads</option>
                        <option value="3">Envelopes</option>
                        <option value="4">Notecards</option>
                        <option value="18">Notepads</option>
                        <option value="5">Forms</option>
                        <option value="7">Adult Apparel</option>
                        <option value="8">Promotional</option>
                        {/* <option value="16">Marketing</option> */}
                    </select>
                    <div className="button" onClick={handleSearch}>Search</div>
                </div>
            </div>
            <div className="templates-row">
                {renderDepartments()}
            </div>
        </div>
    );
}

export default TemplatesP7;
